import { initApp } from './app';
import { initModals } from '../../components/modals';
import { initConsentManagement } from '../../helpers/consent-management.js';
import { initTracking } from '../../tracking';
import { initShowToggles } from '../../helpers/hide-show';
import { initCaptchas } from '../../helpers/captchas';
import { initFreeTrials } from '../../forms/free-trial';
import { initQuickorder } from '../../forms/quickorder';
import { initAdvancedSelects } from '../../forms/advanced-select';
import { generateUuid } from '../../helpers/strings';
import { ConsentFormHandlerFactory } from '../../forms/consent-form-handler/ConsentFormHandlerFactory';
import { EbueroConsentFormHandler } from '../../forms/consent-form-handler/EbueroConsentFormHandler';
import { generalCallbacks } from '../../form-callbacks/general';
import { consentCallbacks } from '../../form-callbacks/consent';
import { freeTrialCallbacks } from '../../form-callbacks/free-trial';
import { quickorderCallbacks } from '../../form-callbacks/quickorder';
import { callbackCallbacks } from '../../form-callbacks/callback';
import { offerCallbacks } from '../../form-callbacks/offer';
import { thankYouPageCallbacks } from './thank-you-page-callback';

const initialize = () => {
	ConsentFormHandlerFactory.getInstance().registerHandler(new EbueroConsentFormHandler());

	try {
		initApp();
	} catch (e) {
		console.log(e);
	}

	try {
		initModals();
	} catch (e) {
		console.log(e);
	}

	try {
		initTracking();
	} catch (e) {
		console.log(e);
	}

	try {
		initConsentManagement();
	} catch (e) {
		console.log(e);
	}

	try {
		initShowToggles();
	} catch (e) {
		console.log(e);
	}

	try {
		initAdvancedSelects();
	} catch (e) {
		console.log(e);
	}

	try {
		initFreeTrials();
	} catch (e) {
		console.log(e);
	}

	try {
		initQuickorder();
	} catch (e) {
		console.log(e);
	}

	try {
		initCaptchas();
	} catch (e) {
		console.log(e);
	}
};

Object.assign(
	window,
	generalCallbacks,
	consentCallbacks,
	quickorderCallbacks,
	callbackCallbacks,
	offerCallbacks,
	freeTrialCallbacks,
	thankYouPageCallbacks
);

initialize();
window.generateUuid = generateUuid;

// Process all libsLoadedScripts directly now
window.addLibsLoadedScript = (fn) => fn();

// Execute all scripts that have been queued for execution
if (typeof window.libsLoadedScripts === 'object') {
	window.libsLoadedScripts.forEach((fn) => {
		try {
			fn();
		} catch (e) {
			console.error(e);
		}
	});
}
